'use client'

// Infra-error boundary, distinct from the unknown-slug `notFound()` path: a
// backend outage shows "temporarily unavailable", never a misleading
// "school not found".
export default function Error({ reset }: { error: Error; reset: () => void }) {
  return (
    <main className="bg-background text-foreground grid min-h-screen place-items-center px-6 text-center font-sans">
      <div className="max-w-md">
        <h1 className="text-2xl font-extrabold tracking-[-.3px]">Events are temporarily unavailable</h1>
        <p className="text-muted-foreground mt-2">
          We couldn’t load this page right now. Please try again in a moment.
        </p>
        <button
          type="button"
          onClick={reset}
          className="bg-primary text-primary-foreground mt-6 rounded-full px-6 py-3 font-bold hover:opacity-90"
        >
          Try again
        </button>
      </div>
    </main>
  )
}
